import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@youngcapital/component-library';

import { ACTIVE_KEY, COMPLETE_KEY, PENDING_KEY } from './constants';

import ProgressCardItem from '../ProgressCardItem';

export const getStepState = (stepIndex, currentPageIndex) => {
  if (currentPageIndex > stepIndex) return COMPLETE_KEY;
  if (currentPageIndex === stepIndex) return ACTIVE_KEY;
  return PENDING_KEY;
};

const ProgressCard = ({ currentPageIndex, pages, t }) => {
  const sidebarTitles = t('fieldset_progress_card.title_page');
  return (
    <Card>
      <h3>
        {t('fieldset_progress_card.title', {
          pageNumber: currentPageIndex + 1
        })}
      </h3>
      <ul className='list list--steps list--progress'>
        {pages.map((_, i) => (
          <ProgressCardItem
            state={getStepState(i, currentPageIndex)}
            isLastStep={pages.length === i + 1}
            label={sidebarTitles[i]}
            key={i}
          />
        ))}
      </ul>
    </Card>
  );
};

ProgressCard.propTypes = {
  currentPageIndex: PropTypes.number.isRequired,
  pages: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default ProgressCard;
